export const EXCEL_MEDIA_TYPE =
  "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,";
export const EXCEL_FILE_MIME =
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
export const ACCEPT_XLSX_FILE =
  ".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel";
export let COLUMN_NAMES = [
  {
    field: "seller_id",
    name: "Seller",
    id: 0,
    checked: false,
  },
  {
    field: "merchant_sku",
    name: "Merchant SKU",
    id: 1,
    checked: false,
  },
  {
    field: "asin",
    name: "ASIN",
    id: 2,
    checked: false,
  },
  {
    field: "description",
    name: "Description",
    id: 3,
    checked: false,
  },
  {
    field: "fba_storage_category",
    name: "FBA Storage Category",
    id: 4,
    checked: false,
  },
  {
    field: "cubic_feet_per_unit",
    name: "Cubic Feet Per Unit",
    id: 5,
    checked: false,
  },
  {
    field: "avg_daily",
    name: "Average Daily",
    id: 6,
    checked: false,
  },
  {
    field: "forecast",
    name: "Forecast",
    id: 7,
    checked: false,
  },
  {
    field: "manual_forecast",
    name: "Manual Forecast",
    id: 8,
    checked: false,
  },
  {
    field: "inbound",
    name: "Inbound",
    id: 9,
    checked: false,
  },
  {
    field: "inbound_manual",
    name: "Inbound (Manual Adj)",
    id: 10,
    checked: false,
  },
  {
    field: "at_amazon",
    name: "At Amazon",
    id: 11,
    checked: false,
  },
  {
    field: "total_inventory",
    name: "Total Inventory",
    id: 12,
    checked: false,
  },
  {
    field: "dos_goal",
    name: "Days of Supply Goal",
    id: 13,
    checked: false,
  },
  {
    field: "fba_current_dos",
    name: "FBA Current DOS",
    id: 14,
    checked: false,
  },
  {
    field: "cubic_feet_usage",
    name: "Cu Ft Usage",
    id: 15,
    checked: false,
  },
  {
    field: "target_inventory_units",
    name: "Inv Target (Units)",
    id: 16,
    checked: false,
  },
  {
    field: "shipment_goal_units",
    name: "Shipment Goal (Units)",
    id: 17,
    checked: false,
  },
  {
    field: "available_inventory_at_client",
    name: "Avail Inv at Client",
    id: 18,
    checked: false,
  },
  {
    field: "client_limited_shipment_goal",
    name: "Client Limited Shipment Goal",
    id: 19,
    checked: false,
  },
  {
    field: "rounding_threshold",
    name: "Rounding Threshold",
    id: 20,
    checked: false,
  },
  {
    field: "rounding_threshold_to_ship",
    name: "Rounding Threshold to Ship (Manual Adj.)",
    id: 21,
    checked: false,
  },
  {
    field: "rounding_qty",
    name: "Rounding Qty",
    id: 22,
    checked: false,
  },
  {
    field: "rounding_constraint_ship_goal",
    name: "Rounding Constraint Ship Goal",
    id: 23,
    checked: false,
  },
  {
    field: "ship_rounding_threshold_qty",
    name: "Ideal to ship Rounding Threshold Qty",
    id: 24,
    checked: false,
  },
  {
    field: "restock_allocation_by_class",
    name: "Restock Allocation By Classification",
    id: 25,
    checked: false,
  },
  {
    field: "unit_limited_restock",
    name: "Unit Limited Restock",
    id: 26,
    checked: false,
  },
  {
    field: "unit_limited_shipment_goal",
    name: "Unit Limited Shipment Goal (cubic feet)",
    id: 27,
    checked: false,
  },
  {
    field: "restock_allocation_cubic_feet",
    name: "Restock Allocation Cubic Feet",
    id: 28,
    checked: false,
  },
  {
    field: "case_pack_quantity",
    name: "Case Pack Quantity",
    id: 29,
    checked: false,
  },
  {
    field: "pallet_quantity_units",
    name: "Pallet Quantity (Units)",
    id: 30,
    checked: false,
  },
  {
    field: "cubic_feet_limited_restock_goal",
    name: "Cubic Feet Limited Restock Goal",
    id: 31,
    checked: false,
  },
  {
    field: "total_units_sending",
    name: "Total Units Sending",
    id: 32,
    checked: false,
  },
  {
    field: "shipment_cu_ft",
    name: "Shipment Cu Ft",
    id: 33,
    checked: false,
  },
  {
    field: "d_o_s_after_shipment",
    name: "DOS After Shipment",
    id: 34,
    checked: false,
  },
  {
    field: "shipment_cost",
    name: "Shipment Cost",
    id: 35,
    checked: false,
  },
  {
    field: "shipment_addtl_storage_cost",
    name: "Shipment Addtl Storage Cost",
    id: 36,
    checked: false,
  },
  {
    field: "shipping_cost_per_method_unit",
    name: "Shipment Cost Per Method Unit",
    id: 37,
    checked: false,
  },
  {
    field: "updated_at",
    name: "Updated Date",
    id: 38,
    checked: false,
  },
  {
    field: "seller_location",
    name: "Seller Location",
    id: 39,
    checked: false,
  },
  {
    field: "actions",
    name: "Edit",
    id: 40,
    checked: false,
  },
];

export const SELLERS = [
  { checked: false, id: "BTLUS", name: "BTLUS" },
  { checked: false, id: "ASIS", name: "ASIS" },
  { checked: false, id: "BabyToLove", name: "BabyToLove" },
  { checked: false, id: "Payless", name: "Payless" },
  { checked: false, id: "APOLLO", name: "APOLLO" },
  { checked: false, id: "Forte", name: "Forte" },
];

export const LEGEND_COLORS = {
  Amazon_Data: "#cddc39",
  Amazon_Payment_View: "#a39ced",
  PL_View: "orange",
  Accounting_View: "yellow",
};
